import React from 'react'
import PropTypes from 'prop-types'
import Asset from './Asset/index'

import './index.css'

const PRODUCT_TYPE_FILTERS = {
  FloorPlansProduct: a => a.node.__typename === 'PhotoAsset',  // filter out non-photos
}

const getProductAssets = (product) => {
  const assets = product.assets.edges

  const filter = PRODUCT_TYPE_FILTERS[product.__typename]
  if (filter) {
    return assets.filter(filter)
  }

  return assets
}

const PhotoAssetRenderer = ({product, onAssetClick}) => {
  const assets = getProductAssets(product)

  const isPhotoProduct = product.assets.edges[0].node.__typename === 'PhotoAsset'
  return (
    <div className={`asset-container ${isPhotoProduct ? 'photo-product' : ''}`}>
    {
      assets.map(({node: asset}, assetIndex) => { return (
        <Asset
          key={assetIndex}
          asset={asset}
          product={product}
          onClick={() => onAssetClick({assetIndex, asset, product})}
        />
      )})
    }
    </div>
  )}

PhotoAssetRenderer.propTypes = {
  product: PropTypes.object.isRequired,
  onAssetClick: PropTypes.func.isRequired,
}

export default PhotoAssetRenderer
